import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const examinationEntityAdapter: EntityAdapter = {
  entity: "examination",
  adjustEditPresetValues: (presetValues) =>
    presetValues.examination_tracked_service_template_set
      ? {
          ...presetValues,
          examination_tracked_service_template_set:
            presetValues.examination_tracked_service_template_set.map((item: any) => ({
              id: item.tracked_service_template.id,
            })),
        }
      : presetValues,
  runsAdditionalCreateCallbackOnCreate: true,
};
